"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDataWidget = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../../common");
var components_1 = require("../../../components");
require("./GKDataWidget.css");
/**
 * Simple widget for displaying a key-value pair, with optional tooltip and link (button)
 */
var GKDataWidget = function (props) {
    var _a = (0, common_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-data-widget",
        className: props.hero ? "hero" : "",
    }), id = _a.id, children = _a.children, color = _a.color, label = _a.label, linkButtonRef = _a.linkButtonRef, linkText = _a.linkText, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hero = _a.hero, tooltip = _a.tooltip, value = _a.value, onLinkClicked = _a.onLinkClicked, estimated = _a.estimated, mergedProps = __rest(_a, ["id", "children", "color", "label", "linkButtonRef", "linkText", "hero", "tooltip", "value", "onLinkClicked", "estimated"]);
    var iconRef = React.useRef(null);
    var persistentId = (0, common_1.usePersistentId2)(id);
    var baseQa = mergedProps["data-qa"];
    return (React.createElement("div", __assign({ id: persistentId }, mergedProps),
        React.createElement("div", { className: "gk-widget-label", "data-qa": baseQa + "--label", id: persistentId + "-label" },
            label,
            tooltip && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "small" },
                    React.createElement(components_1.GKIcon, { id: persistentId + "-help-icon", "data-qa": baseQa + "--help-icon", name: components_1.GKIconName.HelpOutline, className: "pl-1 align-baseline", ref: iconRef })),
                React.createElement(components_1.GKTooltip, { target: iconRef, "data-qa": baseQa + "--help-tooltip" }, tooltip)))),
        React.createElement("div", { className: "d-flex" },
            React.createElement("div", { "aria-labelledby": persistentId + "-label", className: "gk-widget-value flex-grow-1" + (estimated ? " estimated" : ""), "data-qa": baseQa + "--value", id: persistentId + "-data", style: { color: color } }, value),
            children && (React.createElement("div", { className: "gk-widget-extra-content ml-auto", "data-qa": baseQa + "--extras" }, children))),
        linkText &&
            (onLinkClicked ? (React.createElement(components_1.GKButton, { "data-qa": baseQa + "--link", className: "gk-widget-link", color: "link", innerRef: linkButtonRef, size: "sm", onClick: onLinkClicked }, linkText)) : (React.createElement("div", { "data-qa": baseQa + "--subtext", className: "gk-widget-subtext" }, linkText)))));
};
exports.GKDataWidget = GKDataWidget;
exports.default = exports.GKDataWidget;
